import { render, staticRenderFns } from "./verResultado.vue?vue&type=template&id=31687956&scoped=true"
import script from "./verResultado.vue?vue&type=script&lang=js"
export * from "./verResultado.vue?vue&type=script&lang=js"
import style0 from "./verResultado.vue?vue&type=style&index=0&id=31687956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31687956",
  null
  
)

export default component.exports